module.exports = __webpack_public_path__ + "img/empty-watch-list.e4845171.svg";